var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TabsLayout,[_c('ElTabPane',{attrs:{"name":"uploadingIndex","label":"素材上传"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }